import posthog from 'posthog-js';

let initialized = false;

export function initPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY;
  const host = import.meta.env.VITE_POSTHOG_HOST;
  if (!key) return;

  posthog.init(key, {
    api_host: host || 'https://us.i.posthog.com',
    autocapture: false,
    capture_pageview: true,
    capture_pageleave: true,
    disable_session_recording: true,
    persistence: 'localStorage',
  });

  posthog.register({ app: 'web' });

  initialized = true;
}

export function track(event: string, properties?: Record<string, unknown>) {
  if (!initialized) return;
  posthog.capture(event, properties);
}

export const EVENTS = {
  chart_exported: 'chart_exported',
  chart_imported: 'chart_imported',
} as const;